// extracted by mini-css-extract-plugin
module.exports = {"footer-wrapper":"_39EsVdHlEDwxK1vOb4SpMa","footerWrapper":"_39EsVdHlEDwxK1vOb4SpMa","quick-div":"_1-7wHhe9__vC8KEBAtKnWI","quickDiv":"_1-7wHhe9__vC8KEBAtKnWI"};